"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3728],{

/***/ 72409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgArrowBack = function SvgArrowBack(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M47.116 20.882h.086-32.868L27.497 8.218c.516-.49.817-1.186.817-1.923 0-.736-.3-1.39-.817-1.922l-1.68-1.596C25.302 2.287 24.57 2 23.796 2c-.775 0-1.464.286-2.023.777L.818 22.805A2.654 2.654 0 0 0 0 24.727c0 .737.301 1.391.818 1.923l20.954 20.027c.516.491 1.248.778 2.023.778.775 0 1.463-.287 2.023-.778l1.679-1.595c.516-.491.817-1.187.817-1.923s-.3-1.35-.817-1.882L14.205 28.573h32.911c1.55 0 2.884-1.268 2.884-2.782V23.5c0-1.432-1.334-2.618-2.884-2.618Z"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgArrowBack);

/***/ }),

/***/ 34275:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8.8a.8.8 0 0 0-1.6 0v.8h-.8A2.4 2.4 0 0 0 0 4v9.6A2.4 2.4 0 0 0 2.4 16h11.2a2.4 2.4 0 0 0 2.4-2.4V4a2.4 2.4 0 0 0-2.4-2.4h-.8V.8a.8.8 0 1 0-1.6 0v.8H4.8V.8ZM1.6 6.4v7.2a.8.8 0 0 0 .8.8h11.2a.8.8 0 0 0 .8-.8V6.4H1.6Zm1.6 2.4A.8.8 0 0 1 4 8h1.6a.8.8 0 0 1 .8.8v1.6a.8.8 0 0 1-.8.8H4a.8.8 0 0 1-.8-.8V8.8Z",
    fill: "currentColor"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgCalendar);

/***/ }),

/***/ 36016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgThumbsUp = function SvgThumbsUp(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M29.909 3c.843 0 1.599.094 2.269.28.669.188 1.218.42 1.65.695.43.277.797.637 1.1 1.083.301.445.521.847.66 1.203.136.356.246.802.33 1.336.081.535.128.936.137 1.203.008.268.013.615.013 1.043 0 .677-.086 1.354-.26 2.031-.175.678-.349 1.212-.523 1.604a21.86 21.86 0 0 1-1.03 1.978c-.129.214-.23.41-.303.588a6.603 6.603 0 0 0-.22.642h7.616c1.43 0 2.667.508 3.711 1.524 1.043 1.016 1.566 2.219 1.566 3.609 0 1.533-.504 2.86-1.512 3.983.275.784.412 1.461.41 2.032.055 1.354-.339 2.575-1.182 3.662.311.998.311 2.04 0 3.127-.274 1.016-.77 1.853-1.484 2.512.164 1.996-.285 3.61-1.348 4.839-1.173 1.354-2.978 2.05-5.416 2.085h-3.547c-1.21 0-2.529-.139-3.959-.415-1.428-.276-2.543-.535-3.34-.775-.797-.24-1.901-.593-3.312-1.056-2.255-.766-3.703-1.158-4.345-1.176a1.843 1.843 0 0 1-1.237-.522 1.579 1.579 0 0 1-.522-1.189V21.792c0-.446.165-.833.495-1.163.33-.33.724-.513 1.182-.548.44-.036 1.136-.561 2.09-1.578a49.419 49.419 0 0 0 2.776-3.234c1.247-1.55 2.173-2.62 2.777-3.207.33-.321.614-.749.853-1.284.238-.534.399-.966.481-1.296.083-.33.206-.868.372-1.617a25.24 25.24 0 0 1 .343-1.63c.1-.393.28-.856.536-1.39.257-.535.569-.98.935-1.337.349-.339.761-.508 1.238-.508ZM11.686 20.963c.427 0 .797.17 1.11.508.312.339.469.74.469 1.203v17.108c0 .463-.157.864-.47 1.203-.312.338-.682.508-1.11.508H4.58c-.428 0-.798-.17-1.111-.508A1.715 1.715 0 0 1 3 39.782V22.674c0-.463.156-.864.469-1.203.312-.338.683-.508 1.11-.508ZM7.738 34.65c-.445 0-.819.17-1.123.508a1.74 1.74 0 0 0-.456 1.203c0 .481.152.887.456 1.216.304.33.678.495 1.123.495.427 0 .797-.165 1.11-.495.313-.33.469-.735.469-1.216 0-.463-.156-.864-.47-1.203-.312-.338-.682-.508-1.11-.508Z"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgThumbsUp);

/***/ }),

/***/ 5966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ Arrow; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 3 modules
var emotion_styled_base_browser_esm = __webpack_require__(61516);
// EXTERNAL MODULE: ./public/static/arrow.svg
var arrow = __webpack_require__(59846);
;// CONCATENATED MODULE: ./src/components/atoms/arrow/arrow.style.tsx


var arrowSize = {
  S: {
    heigth: '10px',
    width: '8px'
  },
  M: {
    heigth: '18px',
    width: '14px'
  },
  L: {
    heigth: '37px',
    width: '19px'
  }
};
var arrowOrientation = {
  left: 'scale(-1)',
  up: 'rotate(-90deg)',
  down: 'rotate(90deg)',
  right: 'rotate(0)'
};
var StyledArrow = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(arrow/* default */.Z,  true ? {
  target: "e15shu8h0"
} : 0)("height:", function (props) {
  return arrowSize[props.size || 'M'].heigth;
}, ";width:", function (props) {
  return arrowSize[props.size || 'M'].width;
}, ";path{height:", function (props) {
  return arrowSize[props.size || 'M'].heigth;
}, ";width:", function (props) {
  return arrowSize[props.size || 'M'].width;
}, ";}transform:", function (props) {
  return arrowOrientation[props.orientation || 'right'];
}, ";fill:", function (props) {
  return props.theme.icon.brandColor1;
}, ";z-index:1;" + ( true ? "" : 0));
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./src/components/atoms/arrow/arrow.tsx


var _excluded = ["currentSlide", "slideCount"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var Arrow = function Arrow(_ref) {
  var currentSlide = _ref.currentSlide,
      slideCount = _ref.slideCount,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledArrow, _objectSpread({}, props));
};

/***/ }),

/***/ 39795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* binding */ CalendarModal; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/translation-service.ts
var translation_service = __webpack_require__(21449);
// EXTERNAL MODULE: ./src/components/atoms/dreamlines-button/dreamlines-button.tsx
var dreamlines_button = __webpack_require__(2730);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 3 modules
var format = __webpack_require__(32912);
// EXTERNAL MODULE: ./node_modules/react-day-picker/DayPicker.js
var DayPicker = __webpack_require__(27211);
var DayPicker_default = /*#__PURE__*/__webpack_require__.n(DayPicker);
// EXTERNAL MODULE: ./node_modules/react-day-picker/lib/style.css
var style = __webpack_require__(18439);
// EXTERNAL MODULE: ./src/contexts/locale-config/locale-config.tsx
var locale_config = __webpack_require__(36097);
// EXTERNAL MODULE: ./src/components/molecules/cruise-search-mask/cruise-search-mask.tsx + 3 modules
var cruise_search_mask = __webpack_require__(1544);
// EXTERNAL MODULE: ./src/components/molecules/calendar/calendar.style.tsx
var calendar_style = __webpack_require__(36015);
// EXTERNAL MODULE: ./src/components/molecules/calendar/localization.ts
var localization = __webpack_require__(5675);
// EXTERNAL MODULE: ./src/utils/EventTracker.ts
var EventTracker = __webpack_require__(6946);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./src/components/molecules/calendar/calendar-modal.tsx














var Calendar = function Calendar(props) {
  var _localeConfig$code, _MONTHS$locale, _WEEKDAYS_SHORT$local, _props$focusId;

  var _React$useState = react.useState(props.startDate),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      startDate = _React$useState2[0],
      setStartDate = _React$useState2[1];

  var _React$useState3 = react.useState(props.endDate),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      endDate = _React$useState4[0],
      setEndDate = _React$useState4[1];

  var _React$useState5 = react.useState(props.focusedInput),
      _React$useState6 = (0,slicedToArray/* default */.Z)(_React$useState5, 2),
      focusedInput = _React$useState6[0],
      setFocusedInput = _React$useState6[1];

  var localeConfig = react.useContext(locale_config/* LocaleConfigContext */.nO);
  var endInputRef = react.useRef(null);
  var startInputRef = react.useRef(null);
  react.useEffect(function () {
    if (!props.startDate && !props.endDate) {
      // Reset via props (used on mobile)
      setStartDate(undefined);
      setEndDate(undefined);
    }
  }, [props.startDate, props.endDate]); //Using the local state focusInput for animation.

  react.useEffect(function () {
    return focus(props.focusedInput);
  }, [props.focusedInput]);
  var modifiers = {
    start: startDate,
    end: endDate
  };
  react.useEffect(function () {
    var _props$onDateChange;

    (_props$onDateChange = props.onDateChange) === null || _props$onDateChange === void 0 ? void 0 : _props$onDateChange.call(props, {
      startDate: startDate,
      endDate: endDate
    });
  }, [props.onDateChange, startDate, endDate]);

  var changeDate = function changeDate(date, type) {
    if (type) {
      EventTracker/* eventTracker.ga4Track */.xT.ga4Track('search_filters', {
        page_type: 'Ship Landing Page',
        event_type: cruise_search_mask/* dateTypeEventMap */.j[type]
      });
    }

    if (type === 'startDate') setStartDate(date);
    if (type === 'endDate') setEndDate(date);
  }; // Format the date in the input field.


  var formatDate = function formatDate(date) {
    return date ? (0,format/* default */.Z)(date, (0,localization/* getDateFormatByLocale */.NT)(localeConfig.code)) : '';
  };

  var focus = function focus(type) {
    setFocusedInput(type);

    if (type === 'startDate') {
      var _startInputRef$curren;

      startInputRef === null || startInputRef === void 0 ? void 0 : (_startInputRef$curren = startInputRef.current) === null || _startInputRef$curren === void 0 ? void 0 : _startInputRef$curren.focus();
    } else {
      var _endInputRef$current;

      endInputRef === null || endInputRef === void 0 ? void 0 : (_endInputRef$current = endInputRef.current) === null || _endInputRef$current === void 0 ? void 0 : _endInputRef$current.focus();
    }
  };

  var flipFocus = function flipFocus() {
    if (focusedInput === 'startDate') {
      var _endInputRef$current2;

      endInputRef === null || endInputRef === void 0 ? void 0 : (_endInputRef$current2 = endInputRef.current) === null || _endInputRef$current2 === void 0 ? void 0 : _endInputRef$current2.focus();
    } else {
      var _startInputRef$curren2;

      startInputRef === null || startInputRef === void 0 ? void 0 : (_startInputRef$curren2 = startInputRef.current) === null || _startInputRef$curren2 === void 0 ? void 0 : _startInputRef$curren2.focus();
    }
  };

  var resetDate = function resetDate(type) {
    focus(type);
    if (type === 'startDate') setStartDate(undefined);
    if (type === 'endDate') setEndDate(undefined);
  };

  var locale = (_localeConfig$code = localeConfig.code) !== null && _localeConfig$code !== void 0 ? _localeConfig$code : 'en';
  var months = (_MONTHS$locale = localization/* MONTHS */.gg[locale]) !== null && _MONTHS$locale !== void 0 && _MONTHS$locale.length ? localization/* MONTHS */.gg[locale] : localization/* MONTHS.us */.gg.us;
  var weekdaysShort = (_WEEKDAYS_SHORT$local = localization/* WEEKDAYS_SHORT */.Gu[locale]) !== null && _WEEKDAYS_SHORT$local !== void 0 && _WEEKDAYS_SHORT$local.length ? localization/* WEEKDAYS_SHORT */.Gu[locale] : localization/* WEEKDAYS_SHORT.us */.Gu.us;
  var firstDayOfWeek = localization/* FIRST_DAY_OF_WEEK */.rN[locale] ? localization/* FIRST_DAY_OF_WEEK */.rN[locale] : localization/* FIRST_DAY_OF_WEEK.us */.rN.us;
  var focusId = (_props$focusId = props.focusId) !== null && _props$focusId !== void 0 ? _props$focusId : true;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(calendar_style/* StyledCalendarWrapper */.t8, {
    isModal: true,
    open: focusId ? focusedInput : null,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(calendar_style/* StyledStartDateWrapper */.qN, {
        children: [startDate && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(calendar_style/* StyledXIcon */.HY, {
          onClick: function onClick() {
            return resetDate('startDate');
          }
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
          ref: startInputRef,
          onFocus: function onFocus() {
            return setFocusedInput('startDate');
          },
          value: formatDate(startDate),
          placeholder: (0,translation_service.__)('startDatePlaceholder'),
          readOnly: true
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(calendar_style/* StyledEndDateWrapper */.th, {
        hideSeparator: props.hideSeparator,
        children: [endDate && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(calendar_style/* StyledXIcon */.HY, {
          onClick: function onClick() {
            return resetDate('endDate');
          }
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
          ref: endInputRef,
          onFocus: function onFocus() {
            return setFocusedInput('endDate');
          },
          value: formatDate(endDate),
          placeholder: (0,translation_service.__)('endDatePlaceholder'),
          readOnly: true
        })]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((DayPicker_default()), {
      selectedDays: [startDate, {
        from: startDate,
        to: endDate
      }],
      disabledDays: {
        before: new Date()
      },
      modifiers: modifiers,
      numberOfMonths: 24,
      onDayClick: function onDayClick(day) {
        changeDate(day, focusedInput);
        flipFocus();
      },
      locale: locale,
      months: months,
      weekdaysShort: weekdaysShort,
      pagedNavigation: false,
      firstDayOfWeek: firstDayOfWeek
    })]
  });
};

/* harmony default export */ var calendar_modal = (Calendar);
// EXTERNAL MODULE: ./src/components/molecules/modal/modal.tsx + 1 modules
var modal = __webpack_require__(52753);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 3 modules
var emotion_styled_base_browser_esm = __webpack_require__(61516);
;// CONCATENATED MODULE: ./src/components/molecules/calendar-modal/calendar-modal.style.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var StyledSubmitDate = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eln3nmi1"
} : 0)( true ? {
  name: "15m4esl",
  styles: "position:fixed;bottom:0;left:0;width:100%;z-index:1;button{width:100%;border-radius:0;}"
} : 0);
var StyledCalendar = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eln3nmi0"
} : 0)("height:100%;.DateRangePicker{box-shadow:", function (props) {
  return props.theme.boxShadow.modalInput;
}, ";border:", function (props) {
  return "solid 1px ".concat(props.theme.shades.lightGrey);
}, ";&_picker{width:calc(100% + 24px);border:0;box-shadow:none;top:65px!important;overflow:auto;margin-left:-12px;margin-right:-12px;left:0!important;}}.DayPicker{&__withBorder{box-shadow:none;}&_transitionContainer{&__vertical{overflow:unset;}}}.CalendarDay{&__selected{&_start{&:before,&:after{left:33px;}}&_end{&:before,&:after{right:33px;}}&_start,&_end{&:before,&:after{border-width:22px;margin-top:-23px;}}}}.DayPickerNavigation{display:none;}.CalendarMonth{&_caption{padding-bottom:0;}}.CalendarMonthGrid{&>div:nth-child(2){.CalendarMonth_caption{padding-bottom:37px;}}&>div:not(:nth-child(1)){border-bottom:", function (props) {
  return "1px solid ".concat(props.theme.colors.separator);
}, ";padding-bottom:1em;}}.DateInput{&_input{height:50px;padding-left:32px;}}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./src/components/molecules/calendar-modal/input/input.style.tsx


function input_style_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var StyledCalendarWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1v0jpj83"
} : 0)("display:flex;background-color:", function (props) {
  return props.theme.shades['white-90'];
}, ";align-items:center;position:relative;" + ( true ? "" : 0));
var StyledInputWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1v0jpj82"
} : 0)( true ? {
  name: "36bnqj",
  styles: "display:flex;flex:1"
} : 0);
var InputSeparator = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1v0jpj81"
} : 0)("display:flex;height:30px;border-right:1px solid ", function (props) {
  return props.theme.colors.separator;
}, ";" + ( true ? "" : 0));
var Input = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("input",  true ? {
  target: "e1v0jpj80"
} : 0)("font-family:NotoSans,Helvetica,sans-serif;padding:0 0 0 32px;height:50px;font-size:", function (props) {
  return props.theme.fontSize.regularS;
}, ";background-color:transparent;border:0;width:100%;color:", function (props) {
  return props.theme.shades.blackGrey;
}, ";border-radius:0;&::-webkit-input-placeholder{line-height:1.5;}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./src/components/molecules/calendar-modal/input/input.tsx









var CalendarInput = function CalendarInput(props) {
  var localeConfig = react.useContext(locale_config/* LocaleConfigContext */.nO);
  var dateFormat = (0,localization/* getDateFormatByLocale */.NT)(localeConfig.code);
  var startDate = props.startDate ? (0,format/* default */.Z)(props.startDate, dateFormat) : '';
  var endDate = props.endDate ? (0,format/* default */.Z)(props.endDate, dateFormat) : '';
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledCalendarWrapper, {
    className: props.className,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledInputWrapper, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(calendar_style/* StyledCalendarSVG */.Gy, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input, {
        type: "text",
        "aria-label": (0,translation_service.__)('startDatePlaceholder'),
        id: "START_DATE",
        name: "START_DATE",
        value: startDate,
        placeholder: (0,translation_service.__)('startDatePlaceholder'),
        autoComplete: "off",
        "aria-describedby": "DateInput__screen-reader-message-START_DATE",
        onClick: function onClick() {
          return props.onClick('startDate');
        },
        readOnly: true
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InputSeparator, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledInputWrapper, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(calendar_style/* StyledCalendarSVG */.Gy, {
        second: "true"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input, {
        type: "text",
        "aria-label": (0,translation_service.__)('endDatePlaceholder'),
        id: "END_DATE",
        name: "END_DATE",
        value: endDate,
        placeholder: (0,translation_service.__)('endDatePlaceholder'),
        autoComplete: "off",
        "aria-describedby": "DateInput__screen-reader-message-END_DATE",
        onClick: function onClick() {
          return props.onClick('endDate');
        },
        readOnly: true
      })]
    })]
  });
};
// EXTERNAL MODULE: ./node_modules/@mui/material/Icon/Icon.js + 1 modules
var Icon = __webpack_require__(67564);
;// CONCATENATED MODULE: ./public/static/icons/pegasus_reload.svg
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgPegasusReload = function SvgPegasusReload(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.12 17.12",
    style: {
      enableBackground: "new 0 0 17.12 17.12"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/react.createElement("path", {
    style: {
      fill: "#030104"
    },
    d: "M8.661.001h.034c.019-.002.027 0 .039 0a8.58 8.58 0 0 1 5.955 2.42L16.447.645a.286.286 0 0 1 .314-.065.297.297 0 0 1 .186.271l-.294 6.066h-5.715a.294.294 0 0 1-.145-.548l1.73-1.751c-1.026-.988-2.36-1.529-3.832-1.529-2.993.017-5.433 2.47-5.433 5.51.023 2.978 2.457 5.4 5.481 5.422a5.511 5.511 0 0 0 4.719-3.221l2.803 1.293-.019.039c-1.92 3.713-4.946 5.277-8.192 4.944-4.375-.348-7.848-4.013-7.878-8.52C.171 3.876 3.976.042 8.661.001z"
  }));
};

/* harmony default export */ var pegasus_reload = (SvgPegasusReload);
;// CONCATENATED MODULE: ./src/components/molecules/calendar-modal/reset-button/reset-button.tsx


function reset_button_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var StyledReloadSvg = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(pegasus_reload,  true ? {
  target: "exefrq51"
} : 0)("width:13px;transform:scale3d(-1, 1, 1);fill:", function (props) {
  return props.theme.colors['main4'];
}, ";vertical-align:middle;" + ( true ? "" : 0));

var StyledIcon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Icon/* default */.Z,  true ? {
  target: "exefrq50"
} : 0)( true ? {
  name: "1t89zvq",
  styles: "font-size:11px"
} : 0);

var ResetButton = function ResetButton(props) {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledIcon, {
    onClick: function onClick() {
      return props.onClick();
    },
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledReloadSvg, {}), " ", (0,translation_service.__)('calendarReset')]
  });
};
;// CONCATENATED MODULE: ./src/components/molecules/calendar-modal/calendar-modal.tsx











// @TODO remove the unwanted previous code once tested properly
var CalendarModal = function CalendarModal(props) {
  var _React$useState = react.useState(),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      startDate = _React$useState2[0],
      setStartDate = _React$useState2[1];

  var _React$useState3 = react.useState(),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      endDate = _React$useState4[0],
      setEndDate = _React$useState4[1]; // We need a private values to handle custom inputs shown inside the search mask


  var _React$useState5 = react.useState(),
      _React$useState6 = (0,slicedToArray/* default */.Z)(_React$useState5, 2),
      _startDate = _React$useState6[0],
      _setStartDate = _React$useState6[1];

  var _React$useState7 = react.useState(),
      _React$useState8 = (0,slicedToArray/* default */.Z)(_React$useState7, 2),
      _endDate = _React$useState8[0],
      _setEndDate = _React$useState8[1];

  var _React$useState9 = react.useState(),
      _React$useState10 = (0,slicedToArray/* default */.Z)(_React$useState9, 2),
      focusedInput = _React$useState10[0],
      setFocusedInput = _React$useState10[1];

  var _React$useState11 = react.useState(false),
      _React$useState12 = (0,slicedToArray/* default */.Z)(_React$useState11, 2),
      showModal = _React$useState12[0],
      setShowModal = _React$useState12[1];

  var handleDatesChange = function handleDatesChange(dates) {
    setStartDate(dates.startDate);
    setEndDate(dates.endDate);
  };

  var handleModal = function handleModal(_clickedInput) {
    setShowModal(!showModal);
    setFocusedInput(_clickedInput || null);
  };

  var submitDates = function submitDates() {
    handleModal(null);

    _setStartDate(startDate);

    _setEndDate(endDate);

    props.onDateChange && props.onDateChange({
      startDate: startDate,
      endDate: endDate
    });
  };

  var resetState = function resetState() {
    handleDatesChange({
      startDate: undefined,
      endDate: undefined
    });
    props.onDateChange && props.onDateChange({
      startDate: undefined,
      endDate: undefined
    });

    _setStartDate(undefined);

    _setEndDate(undefined);
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CalendarInput, {
      onClick: handleModal,
      startDate: _startDate,
      endDate: _endDate,
      className: props.className
    }), showModal && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(modal/* Modal */.u, {
      showModal: showModal,
      headerText: (0,translation_service.__)('calendarTravelDate'),
      onClose: function onClose() {
        return handleModal(null);
      },
      rightIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ResetButton, {
        onClick: function onClick() {
          return resetState();
        }
      }),
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCalendar, {
        "data-testid": "calendar-modal",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(calendar_modal, {
          focusedInput: focusedInput,
          onDateChange: handleDatesChange,
          startDate: startDate,
          endDate: endDate,
          isMobile: true
        })
      }), (startDate || endDate) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSubmitDate, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dreamlines_button/* DreamlinesButton */.P, {
          wrapperStyle: {
            width: '100%'
          },
          style: {
            width: '100%',
            height: 60,
            borderRadius: 0
          },
          onClick: submitDates,
          children: (0,translation_service.__)('calendarSubmit')
        })
      })]
    })]
  });
};

/***/ }),

/***/ 36015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gy": function() { return /* binding */ StyledCalendarSVG; },
/* harmony export */   "HY": function() { return /* binding */ StyledXIcon; },
/* harmony export */   "kC": function() { return /* binding */ StyledArrowLeft; },
/* harmony export */   "qN": function() { return /* binding */ StyledStartDateWrapper; },
/* harmony export */   "t8": function() { return /* binding */ StyledCalendarWrapper; },
/* harmony export */   "th": function() { return /* binding */ StyledEndDateWrapper; },
/* harmony export */   "zy": function() { return /* binding */ StyledArrowRight; }
/* harmony export */ });
/* unused harmony export StyledCalendar */
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61516);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70917);
/* harmony import */ var _public_static_arrow_svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59846);
/* harmony import */ var _public_static_icons_calendar_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34275);
/* harmony import */ var _style_global_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43780);
/* harmony import */ var _utils_buildVersion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76577);
/* harmony import */ var _search_dropdown_search_dropdown_style__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69280);


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var assetPrefix = (0,_utils_buildVersion__WEBPACK_IMPORTED_MODULE_4__/* .getAssetsPrefix */ .x)();

var _ref3 =  true ? {
  name: "aomley",
  styles: "transform:translate3d(100%, 1px, 0)"
} : 0;

var _ref4 =  true ? {
  name: "1s1mvpm",
  styles: "transform:translate3d(0, 1px, 0)"
} : 0;

var StyledCalendarWrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e10ed2cs8"
} : 0)("position:relative;color:black;display:flex;flex-direction:row;@media ", _style_global_style__WEBPACK_IMPORTED_MODULE_3__/* .mediaQueries.phone */ .w5.phone, "{box-shadow:rgba(0, 0, 0, 0.11) 0px 8px 7px 0px;border:1px solid rgb(216, 216, 216);}", function (props) {
  if (!props.open) return '';
  return /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(props.isModal ? '> div:first-child' : '&', "::after{content:'';position:absolute;left:0;bottom:0;height:3px;width:50%;background-color:", props.theme.colors.highlightBorder, ";border-radius:1.5px;transition:", "transform ".concat(props.theme.transition.duration.modal, "ms"), ";", props.open === 'startDate' ? _ref4 : props.open === 'endDate' ? _ref3 : null, " z-index:1;}" + ( true ? "" : 0),  true ? "" : 0);
}, " ", function (props) {
  return props.isModal ? '> div:first-child' : '&';
}, ">div{width:50%;position:relative;&:last-child{margin-right:0;}input{width:100%;height:45px;border:0;font-size:14px;background-image:url('", assetPrefix, "/static/icons/calendar.svg');padding-left:30px;background-repeat:no-repeat;background-size:17px 18px;background-position:9px 12px;&:focus{background-color:#ffffff;color:", function (props) {
  return props.theme.shades.lightGrey;
}, ";}}}.DayPicker{&-Caption{text-align:center;padding-top:10px;padding-bottom:5px;&>div{font-size:", function (props) {
  return props.theme.fontSize.regular;
}, ";font-weight:600;text-transform:uppercase;color:#484848;}}&-Weekday{color:", function (props) {
  return props.theme.shades.midGrey;
}, ";font-size:0.825em;}&-Day{font-size:13px;border-radius:0!important;border:0;color:", function (props) {
  return props.theme.shades.blackGrey;
}, ";width:46px;height:45px;padding:1px;position:relative;@media ", _style_global_style__WEBPACK_IMPORTED_MODULE_3__/* .mediaQueries.tabletAndUp */ .w5.tabletAndUp, "{width:26px;height:25px;}&:hover{background:", function (props) {
  return props.theme.colors['main4-10'];
}, ";color:", function (props) {
  return props.theme.shades.darkGrey;
}, ";border:0;}&--disabled{color:", function (props) {
  return props.theme.shades.lightGrey;
}, ";}&--selected{}&--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside){background:", function (props) {
  return props.theme.colors.main4;
}, ";position:relative;&:hover,&:active{color:white;background:", function (props) {
  return props.theme.colors.main4;
}, ";border:0;position:relative;}}&--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(\n                    .DayPicker-Day--outside\n                ){background:rgba(0, 98, 149, 0.2)!important;color:", function (props) {
  return props.theme.shades.blackGrey;
}, ";}&--start:not(.DayPicker-Day--outside),&--end:not(.DayPicker-Day--outside){background:#006295!important;color:white;&:hover,&:active{color:white;background:", function (props) {
  return props.theme.colors.main4;
}, ";border:0;position:relative;}}&--start:not(.DayPicker-Day--outside){z-index:1;&:after,&:before{left:19px;top:50%;border:solid transparent;content:' ';height:0;width:0;position:absolute;pointer-events:none;}&:after{border-color:rgba(136, 183, 213, 0);border-left-color:", function (props) {
  return props.theme.colors.main4;
}, ";border-width:12px;margin-top:-12px;transform:skewX(-30deg);z-index:-1;}&:before{border-color:rgba(194, 225, 245, 0);border-left-color:", function (props) {
  return props.theme.colors.main4;
}, ";border-width:12px;margin-top:-12px;transform:skewX(30deg);z-index:-1;}}&--end:not(.DayPicker-Day--outside){z-index:1;&:after,&:before{right:19px;top:50%;border:solid transparent;content:' ';height:0;width:0;position:absolute;pointer-events:none;}&:after{border-color:rgba(136, 183, 213, 0);border-left-color:", function (props) {
  return props.theme.colors.main4;
}, ";border-width:12px;margin-top:-12px;transform:skewX(-30deg) scale(-1);z-index:-1;}&:before{border-color:rgba(194, 225, 245, 0);border-left-color:", function (props) {
  return props.theme.colors.main4;
}, ";border-width:12px;margin-top:-12px;transform:skewX(30deg) scale(-1);z-index:-1;}}}}.DayPickerInput{display:block;&-Overlay{width:100%;text-align:center;padding-bottom:15px;z-index:2;@media ", _style_global_style__WEBPACK_IMPORTED_MODULE_3__/* .mediaQueries.phone */ .w5.phone, "{height:calc(100vh - 90px);width:calc(100vw - 26px);box-shadow:none;overflow:visible;margin-top:13px;}}}", function (props) {
  if (!props.isModal) return '';
  return /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("flex-direction:column;box-shadow:none!important;border:none!important;height:100%;>div:first-child{position:relative;display:flex;flex-direction:row;justify-content:space-between;@media ", _style_global_style__WEBPACK_IMPORTED_MODULE_3__/* .mediaQueries.phone */ .w5.phone, "{box-shadow:rgba(0, 0, 0, 0.11) 0px 8px 7px 0px;border:1px solid rgb(216, 216, 216);}}.DayPicker{overflow-y:scroll;.DayPicker-NavBar{display:none;}}" + ( true ? "" : 0),  true ? "" : 0);
}, ";" + ( true ? "" : 0));
var StyledStartDateWrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e10ed2cs7"
} : 0)( true ? "" : 0);

var StyledArrow = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_public_static_arrow_svg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,  true ? {
  target: "e10ed2cs6"
} : 0)("fill:", function (props) {
  return props.theme.shades.blackGrey;
}, ";stroke:", function (props) {
  return props.theme.shades.blackGrey;
}, ";width:40px;height:32px;top:10px;position:absolute;padding:5px;cursor:pointer;@media ", _style_global_style__WEBPACK_IMPORTED_MODULE_3__/* .mediaQueries.tabletAndUp */ .w5.tabletAndUp, "{width:21px;height:21px;top:23px;}" + ( true ? "" : 0));

var StyledArrowLeft = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(StyledArrow,  true ? {
  target: "e10ed2cs5"
} : 0)("transform:scale(-1);left:-16px;@media ", _style_global_style__WEBPACK_IMPORTED_MODULE_3__/* .mediaQueries.tabletAndUp */ .w5.tabletAndUp, "{left:10px;}" + ( true ? "" : 0));
var StyledArrowRight = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(StyledArrow,  true ? {
  target: "e10ed2cs4"
} : 0)("right:-16px;@media ", _style_global_style__WEBPACK_IMPORTED_MODULE_3__/* .mediaQueries.tabletAndUp */ .w5.tabletAndUp, "{right:10px;}" + ( true ? "" : 0));
var StyledEndDateWrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e10ed2cs3"
} : 0)(".DayPickerInput{&:before{content:'';width:1px;height:30px;background:#979797;position:absolute;top:8px;display:", function (props) {
  return props.hideSeparator ? 'none' : 'block';
}, ";}}" + ( true ? "" : 0));
var StyledXIcon = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_search_dropdown_search_dropdown_style__WEBPACK_IMPORTED_MODULE_5__/* .XIcon */ .b0,  true ? {
  target: "e10ed2cs2"
} : 0)( true ? {
  name: "zn0dvc",
  styles: "position:absolute;z-index:1;top:50%;transform:translate(-15px, -50%);right:0;cursor:pointer"
} : 0);
var StyledCalendarSVG = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_public_static_icons_calendar_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,  true ? {
  target: "e10ed2cs1"
} : 0)("position:absolute;width:17px;height:18px;z-index:1;top:calc(50% - 1px);@media ", _style_global_style__WEBPACK_IMPORTED_MODULE_3__/* .mediaQueries.phone */ .w5.phone, "{left:", function (props) {
  return props.second === 'true' ? 'calc(50% + 17px)' : '17px';
}, ";}@media ", _style_global_style__WEBPACK_IMPORTED_MODULE_3__/* .mediaQueries.tabletAndUp */ .w5.tabletAndUp, "{left:", function (props) {
  return props.second === 'true' ? 'calc(50% + 20px)' : '20px';
}, ";}transform:translate(-50%, -50%);fill:", function (props) {
  return props.theme.shades.darkGrey;
}, ";color:", function (props) {
  return props.theme.shades.darkGrey;
}, ";" + ( true ? "" : 0));
/** Customized styling */

var _ref =  true ? {
  name: "aomley",
  styles: "transform:translate3d(100%, 1px, 0)"
} : 0;

var _ref2 =  true ? {
  name: "1s1mvpm",
  styles: "transform:translate3d(0, 1px, 0)"
} : 0;

var StyledCalendar = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("div",  true ? {
  target: "e10ed2cs0"
} : 0)("position:relative;.CalendarDay{font-size:13px;&__default{border:0;color:", function (props) {
  return props.theme.shades.blackGrey;
}, ";&:hover{background:", function (props) {
  return props.theme.colors['main4-10'];
}, ";color:", function (props) {
  return props.theme.shades.darkGrey;
}, ";border:0;}}&__hovered{&_offset{border:0;}&_span,&_span:active,&_span:hover{background:", function (props) {
  return props.theme.colors['main4-20'];
}, ";color:", function (props) {
  return props.theme.shades.darkGrey;
}, ";border:0;}}&__blocked{&_minimum_nights{border:0;}&_calendar,&_calendar:active,&_calendar:hover{border:0;}&_out_of_range{color:", function (props) {
  return props.theme.shades.lightGrey;
}, ";}&_out_of_range,&_out_of_range:active,&_out_of_range:hover{border:0;}}&__selected{color:", function (props) {
  return props.theme.shades.white;
}, ";&_span{background:", function (props) {
  return props.theme.colors['main4-20'];
}, ";border:0;color:", function (props) {
  return props.theme.shades.blackGrey;
}, ";&:active,&:hover{background:", function (props) {
  return props.theme.colors['main4-30'];
}, ";color:", function (props) {
  return props.theme.shades.darkGrey;
}, ";border:0;}}&:hover{color:", function (props) {
  return props.theme.shades.white;
}, ";}&_start{z-index:1;&:after,&:before{left:19px;top:50%;border:solid transparent;content:' ';height:0;width:0;position:absolute;pointer-events:none;}&:after{border-color:rgba(136, 183, 213, 0);border-left-color:", function (props) {
  return props.theme.colors.main4;
}, ";border-width:12px;margin-top:-12px;transform:skewX(-30deg);z-index:-1;}&:before{border-color:rgba(194, 225, 245, 0);border-left-color:", function (props) {
  return props.theme.colors.main4;
}, ";border-width:12px;margin-top:-12px;transform:skewX(30deg);z-index:-1;}}&_end{z-index:1;&:after,&:before{right:19px;top:50%;border:solid transparent;content:' ';height:0;width:0;position:absolute;pointer-events:none;}&:after{border-color:rgba(136, 183, 213, 0);border-left-color:", function (props) {
  return props.theme.colors.main4;
}, ";border-width:12px;margin-top:-12px;transform:skewX(-30deg) scale(-1);z-index:-1;}&:before{border-color:rgba(194, 225, 245, 0);border-left-color:", function (props) {
  return props.theme.colors.main4;
}, ";border-width:12px;margin-top:-12px;transform:skewX(30deg) scale(-1);z-index:-1;}}}&__selected,&__selected:active,&__selected:hover{background:", function (props) {
  return props.theme.colors.main4;
}, ";border:0;position:relative;}}.DayPicker{&_weekHeader{top:57px;&_li{color:", function (props) {
  return props.theme.shades.midGrey;
}, ";}}&__withBorder{box-shadow:none;border-radius:0;}}.CalendarMonth{&_caption{strong{font-size:", function (props) {
  return props.theme.fontSize.regular;
}, ";font-weight:600;text-transform:uppercase;}}&_table{margin-top:5px;}}.DateRangePicker{&_picker{top:45px!important;width:100%;}}.DateRangePickerInput{display:flex;align-items:center;background-color:", function (props) {
  return props.open ? props.theme.shades.white : props.theme.shades['white-90'];
}, ";", function (props) {
  if (!props.open) return '';
  return /*#__PURE__*/css("&::after{content:'';position:absolute;left:0;bottom:0;height:3px;width:50%;background-color:", props.theme.colors.highlightBorder, ";border-radius:1.5px;transition:", "transform ".concat(props.theme.transition.duration.modal, "ms"), ";", props.open === 'startDate' ? _ref2 : props.open === 'endDate' ? _ref : null, " z-index:1;}" + ( true ? "" : 0),  true ? "" : 0);
}, ";&_arrow{display:flex;height:30px;}}.DateInput{flex:1;position:relative;display:flex;background-color:transparent;&_fang{display:none;}&_input{font-family:NotoSans,Helvetica,sans-serif;padding:0 0 0 40px;height:45px;background-color:transparent;flex:1;font-size:", function (props) {
  return props.theme.fontSize.regularS;
}, ";display:flex;border-bottom:", function (props) {
  return props.open ? "1px solid ".concat(props.theme.shades.lightGrey) : '1px solid transparent';
}, ";}}" + ( true ? "" : 0))));

/***/ }),

/***/ 58306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ calendar; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInMonths/index.js + 2 modules
var differenceInMonths = __webpack_require__(62337);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 3 modules
var esm_format = __webpack_require__(32912);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isAfter/index.js
var isAfter = __webpack_require__(42699);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-day-picker/DayPickerInput.js
var DayPickerInput = __webpack_require__(86969);
var DayPickerInput_default = /*#__PURE__*/__webpack_require__.n(DayPickerInput);
// EXTERNAL MODULE: ./node_modules/react-day-picker/lib/style.css
var style = __webpack_require__(18439);
// EXTERNAL MODULE: ./src/contexts/locale-config/locale-config.tsx
var locale_config = __webpack_require__(36097);
// EXTERNAL MODULE: ./src/utils/translation-service.ts
var translation_service = __webpack_require__(21449);
// EXTERNAL MODULE: ./src/components/molecules/calendar/calendar.style.tsx
var calendar_style = __webpack_require__(36015);
// EXTERNAL MODULE: ./src/components/molecules/calendar/localization.ts
var localization = __webpack_require__(5675);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./src/components/molecules/calendar/navbar/navbar.tsx




var Navbar = function Navbar(_ref) {
  var onPreviousClick = _ref.onPreviousClick,
      onNextClick = _ref.onNextClick,
      className = _ref.className;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    className: className,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(calendar_style/* StyledArrowLeft */.kC, {
      onClick: function onClick() {
        return onPreviousClick();
      }
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(calendar_style/* StyledArrowRight */.zy, {
      onClick: function onClick() {
        return onNextClick();
      }
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/molecules/calendar/calendar.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var DATE_TYPES = {
  startDate: 'startDate',
  endDate: 'endDate'
};

var Calendar = function Calendar(props) {
  var _MONTHS$localeConfig$, _WEEKDAYS_SHORT$local;

  var _React$useState = react.useState(props.startDate),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      startDate = _React$useState2[0],
      setStartDate = _React$useState2[1];

  var _React$useState3 = react.useState(props.endDate),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      endDate = _React$useState4[0],
      setEndDate = _React$useState4[1];

  var _React$useState5 = react.useState(),
      _React$useState6 = (0,slicedToArray/* default */.Z)(_React$useState5, 2),
      focusedInput = _React$useState6[0],
      setFocusedInput = _React$useState6[1];

  var localeConfig = react.useContext(locale_config/* LocaleConfigContext */.nO);
  var endDatePickerEl = react.useRef();
  var startDatePickerEl = react.useRef();
  var typeOfDate = react.useRef();
  react.useEffect(function () {
    var _props$onDateChange;

    if ((0,isAfter/* default */.Z)(startDate, endDate)) {
      handleDateAfter(typeOfDate.current);
      return;
    }

    (_props$onDateChange = props.onDateChange) === null || _props$onDateChange === void 0 ? void 0 : _props$onDateChange.call(props, {
      startDate: startDate,
      endDate: endDate,
      typeOfDate: typeOfDate.current
    });
  }, [startDate, endDate]);
  react.useEffect(function () {
    // Handle the reset button on modal for mobile
    if (!props.startDate && !props.endDate) {
      setStartDate(undefined);
      setEndDate(undefined);
    }
  }, [props.startDate, props.endDate]); //Using the local state focusInput for animation.

  react.useEffect(function () {
    return setFocusedInput(props.focusedInput);
  }, [props.focusedInput]);
  react.useEffect(function () {
    if (!startDate) {
      return;
    }

    if (endDate && (0,differenceInMonths/* default */.Z)(endDate, startDate) < 2) {
      var _endDatePickerEl$curr;

      (_endDatePickerEl$curr = endDatePickerEl.current.getDayPicker()) === null || _endDatePickerEl$curr === void 0 ? void 0 : _endDatePickerEl$curr.showMonth(startDate);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [endDate]);
  react.useEffect(function () {
    if (props.focusedInput === DATE_TYPES.startDate) {
      startDatePickerEl.current && startDatePickerEl.current.input.focus();
    }

    if (props.focusedInput === DATE_TYPES.endDate) {
      endDatePickerEl.current && endDatePickerEl.current.input.focus();
    }
  }, [props.focusedInput, startDatePickerEl, endDatePickerEl]);
  var modifiers = {
    start: startDate,
    end: endDate
  };

  var handleDateAfter = function handleDateAfter(type) {
    if (type === DATE_TYPES.startDate) {
      setEndDate(undefined);
    }

    if (type === DATE_TYPES.endDate) {
      setStartDate(undefined);
    }
  };

  var handleDateChange = function handleDateChange(date, type) {
    if (type === DATE_TYPES.startDate) {
      setStartDate(date);
    }

    if (type === DATE_TYPES.endDate) {
      setEndDate(date);
    }
  }; //Format the date in the input field.


  var formatDate = function formatDate(date, format) {
    return (0,esm_format/* default */.Z)(date, format);
  };

  var handleResetDate = function handleResetDate(date, type) {
    setFocusedInput(null);
    handleDateChange(date, type);
  };

  var handleFocusChange = function handleFocusChange(focusedInput) {
    typeOfDate.current = focusedInput;
    setFocusedInput(focusedInput);
  };

  var dayPickerLocaleSettings = {
    locale: localeConfig.code || 'en',
    months: (_MONTHS$localeConfig$ = localization/* MONTHS */.gg[localeConfig.code]) !== null && _MONTHS$localeConfig$ !== void 0 && _MONTHS$localeConfig$.length ? localization/* MONTHS */.gg[localeConfig.code] : localization/* MONTHS.us */.gg.us,
    weekdaysShort: (_WEEKDAYS_SHORT$local = localization/* WEEKDAYS_SHORT */.Gu[localeConfig.code]) !== null && _WEEKDAYS_SHORT$local !== void 0 && _WEEKDAYS_SHORT$local.length ? localization/* WEEKDAYS_SHORT */.Gu[localeConfig.code] : localization/* WEEKDAYS_SHORT.us */.Gu.us,
    firstDayOfWeek: localization/* FIRST_DAY_OF_WEEK */.rN[localeConfig.code] ? localization/* FIRST_DAY_OF_WEEK */.rN[localeConfig.code] : localization/* FIRST_DAY_OF_WEEK.us */.rN.us
  };
  var dateFormat = (0,localization/* getDateFormatByLocale */.NT)(localeConfig.code);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(calendar_style/* StyledCalendarWrapper */.t8, {
    open: props.focusIdetifier ? focusedInput : null,
    className: props.className,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(calendar_style/* StyledStartDateWrapper */.qN, {
      children: [startDate && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(calendar_style/* StyledXIcon */.HY, {
        onClick: function onClick() {
          return handleResetDate(undefined, DATE_TYPES.startDate);
        }
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((DayPickerInput_default()), {
        ref: startDatePickerEl,
        value: startDate || (0,translation_service.__)('startDatePlaceholder'),
        placeholder: (0,translation_service.__)('startDatePlaceholder'),
        format: dateFormat,
        formatDate: formatDate,
        inputProps: {
          readOnly: true,
          onBlur: function onBlur() {
            setFocusedInput(null);
          },
          onFocus: function onFocus() {
            return handleFocusChange('startDate');
          }
        },
        keepFocus: props.keepFocus,
        showOverlay: props.showOverlay,
        dayPickerProps: _objectSpread(_objectSpread({
          selectedDays: [startDate, {
            from: startDate,
            to: endDate
          }],
          disabledDays: {
            after: endDate,
            before: new Date()
          },
          toMonth: endDate,
          //users won't be able to navigate after this date.
          modifiers: modifiers,
          numberOfMonths: props.numberOfMonths
        }, dayPickerLocaleSettings), {}, {
          navbarElement: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navbar, {
            idEl: DATE_TYPES.startDate
          })
        }),
        onDayChange: function onDayChange(date) {
          return handleDateChange(date, DATE_TYPES.startDate);
        }
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(calendar_style/* StyledEndDateWrapper */.th, {
      hideSeparator: props.hideSeparator,
      children: [endDate && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(calendar_style/* StyledXIcon */.HY, {
        onClick: function onClick() {
          return handleResetDate(undefined, DATE_TYPES.endDate);
        }
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((DayPickerInput_default()), {
        ref: endDatePickerEl,
        value: endDate || (0,translation_service.__)('endDatePlaceholder'),
        placeholder: (0,translation_service.__)('endDatePlaceholder'),
        format: dateFormat,
        formatDate: formatDate,
        inputProps: {
          readOnly: true,
          onBlur: function onBlur() {
            setFocusedInput(null);
          },
          onFocus: function onFocus() {
            return handleFocusChange('endDate');
          }
        },
        keepFocus: props.keepFocus,
        showOverlay: props.showOverlay,
        dayPickerProps: _objectSpread(_objectSpread({
          selectedDays: [startDate, {
            from: startDate,
            to: endDate
          }],
          disabledDays: {
            before: new Date()
          },
          modifiers: modifiers,
          month: startDate,
          fromMonth: startDate,
          //users won't be able to navigate before this date.
          numberOfMonths: props.numberOfMonths,
          onDayClick: function onDayClick() {
            if (props.isMobile) {
              startDatePickerEl.current && startDatePickerEl.current.input.focus();
            }
          }
        }, dayPickerLocaleSettings), {}, {
          navbarElement: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navbar, {
            idEl: DATE_TYPES.endDate
          })
        }),
        onDayChange: function onDayChange(date) {
          return handleDateChange(date, DATE_TYPES.endDate);
        }
      })]
    })]
  });
};

Calendar.defaultProps = {
  numberOfMonths: 1,
  startDate: undefined,
  endDate: undefined,
  showOverlay: false,
  keepFocus: false,
  focusIdetifier: true
};
/* harmony default export */ var calendar = (Calendar);

/***/ }),

/***/ 5675:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gu": function() { return /* binding */ WEEKDAYS_SHORT; },
/* harmony export */   "NT": function() { return /* binding */ getDateFormatByLocale; },
/* harmony export */   "gg": function() { return /* binding */ MONTHS; },
/* harmony export */   "rN": function() { return /* binding */ FIRST_DAY_OF_WEEK; }
/* harmony export */ });
var engShortWeekDays = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
var engMonths = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
var WEEKDAYS_SHORT = {
  de: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
  ru: ['Нд', 'Пн', 'Аў', 'Ср', 'Чц', 'Пт', 'Сб'],
  it: ['Do', 'Lu', 'Ma', 'Me', 'Gi', 'Ve', 'Sa'],
  fr: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
  nl: ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za'],
  br: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
  us: engShortWeekDays,
  au: engShortWeekDays,
  cn: [],
  uk: engShortWeekDays
}; //Sunday is 0

var FIRST_DAY_OF_WEEK = {
  de: 1,
  ru: 1,
  it: 1,
  fr: 1,
  nl: 1,
  br: 0,
  us: 0,
  au: 1,
  cn: 0,
  uk: 1
};
var MONTHS = {
  de: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
  fr: [],
  nl: [],
  br: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
  us: engMonths,
  au: engMonths,
  cn: [],
  uk: engMonths,
  ru: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
  it: ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre']
};

var getDateFormatByLocale = function getDateFormatByLocale(locale) {
  return locale === 'us' ? 'MM/dd/yyyy' : 'dd.MM.yyyy';
};



/***/ }),

/***/ 62372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "OQ": function() { return /* binding */ ButtonStyled; },
  "oD": function() { return /* binding */ ButtonText; },
  "BN": function() { return /* binding */ StyledBestPrice; },
  "PQ": function() { return /* binding */ StyledContainer; },
  "cF": function() { return /* binding */ StyledDesktopBagdeContainer; },
  "R9": function() { return /* binding */ StyledDreamlinesPackageExpert; },
  "yF": function() { return /* binding */ StyledHeadline; },
  "Le": function() { return /* binding */ StyledHeadlineInner; },
  "QN": function() { return /* binding */ StyledIconWithTextWrapper; },
  "fP": function() { return /* binding */ StyledInnerContainer; },
  "ar": function() { return /* binding */ StyledLabel; },
  "wl": function() { return /* binding */ StyledPreHeadline; },
  "W6": function() { return /* binding */ StyledSelectWrapper; },
  "R6": function() { return /* binding */ StyledSsl; },
  "UJ": function() { return /* binding */ StyledThumbsUp; },
  "mO": function() { return /* binding */ StyledUspContainer; },
  "I7": function() { return /* binding */ StyledWinner; }
});

// UNUSED EXPORTS: StyledHeadlineOutside

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 3 modules
var emotion_styled_base_browser_esm = __webpack_require__(61516);
// EXTERNAL MODULE: ./src/style/global-style.tsx
var global_style = __webpack_require__(43780);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./public/static/icons/winner.svg
var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgWinner = function SvgWinner(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "m15.254 21.595-1.788-1.399-2.158.257-2.804 9.461 3.233-.746 2.349 2.349 2.322-8.102.93-2.903-.112-.033zM19.51 21.107l-1.55-.435-1.161 4.097 1.933 6.75 2.349-2.349 3.24.746-3.055-10.636-.356.046zM16.079 4.031c-3.596 0-6.525 2.929-6.525 6.525s2.93 6.525 6.525 6.525 6.525-2.93 6.525-6.525c0-3.596-2.93-6.525-6.525-6.525zm1.023 10.188h-1.478V8.657a5.177 5.177 0 0 1-1.907 1.122V8.44c.383-.125.805-.363 1.254-.719.449-.35.759-.765.93-1.234h1.201v7.733z"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "m26.128 11.335-1.042-1.854.574-2.052-1.676-1.313-.257-2.111-2.052-.574-1.042-1.854-2.111.251L16.846.515l-1.854 1.042L12.94.983l-1.313 1.676-2.111.257-.574 2.052L7.088 6.01l.251 2.111-1.313 1.663 1.042 1.854-.574 2.052 1.676 1.313.257 2.111 2.052.574 1.036 1.861 2.111-.251 1.676 1.313 1.854-1.042 2.052.574 1.313-1.676 2.111-.257.574-2.052 1.854-1.042-.251-2.111 1.32-1.669zm-10.049 6.453c-3.992 0-7.231-3.24-7.231-7.231s3.24-7.231 7.231-7.231c3.992 0 7.231 3.24 7.231 7.231s-3.24 7.231-7.231 7.231z"
  })));
};

/* harmony default export */ var winner = (SvgWinner);
;// CONCATENATED MODULE: ./public/static/icons/dreamlinesPackage-expert.svg
var dreamlinesPackage_expert_path, dreamlinesPackage_expert_path2;

function dreamlinesPackage_expert_extends() { dreamlinesPackage_expert_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return dreamlinesPackage_expert_extends.apply(this, arguments); }



var SvgDreamlinesPackageExpert = function SvgDreamlinesPackageExpert(props) {
  return /*#__PURE__*/react.createElement("svg", dreamlinesPackage_expert_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), dreamlinesPackage_expert_path || (dreamlinesPackage_expert_path = /*#__PURE__*/react.createElement("path", {
    d: "M27.302 16.884c-3.015-1.214-5.918-1.821-8.703-1.821-2.784 0-5.681.607-8.703 1.821a9.832 9.832 0 0 0-.653.284l.911 2.158 6.248.534a.31.31 0 0 1 .27.218c.04.119 0 .251-.092.337l-4.744 4.111.713 3.068h19.266v-5.938c.007-1.973-1.498-3.556-4.513-4.77zM18.6 13.288c1.808 0 3.352-.647 4.638-1.933s1.933-2.837 1.933-4.638c0-1.808-.647-3.365-1.933-4.678S20.407.066 18.6.066c-1.808 0-3.352.66-4.638 1.973s-1.933 2.877-1.933 4.678c0 1.808.647 3.352 1.933 4.638s2.837 1.933 4.638 1.933z"
  })), dreamlinesPackage_expert_path2 || (dreamlinesPackage_expert_path2 = /*#__PURE__*/react.createElement("path", {
    d: "m9.415 20.005-1.993-4.698-1.993 4.698a.287.287 0 0 1-.231.172l-5.1.435 3.866 3.352a.287.287 0 0 1 .092.277l-1.161 4.988 4.381-2.646a.285.285 0 0 1 .29 0l4.381 2.646-1.161-4.988a.283.283 0 0 1 .092-.277l3.866-3.352-5.1-.435a.282.282 0 0 1-.231-.172z"
  })));
};

/* harmony default export */ var dreamlinesPackage_expert = (SvgDreamlinesPackageExpert);
// EXTERNAL MODULE: ./public/static/icons/thumbsUp.svg
var thumbsUp = __webpack_require__(36016);
// EXTERNAL MODULE: ./src/components/atoms/dreamlines-button/dreamlines-button.tsx
var dreamlines_button = __webpack_require__(2730);
// EXTERNAL MODULE: ./src/utils/buildVersion.ts
var buildVersion = __webpack_require__(76577);
;// CONCATENATED MODULE: ./src/components/molecules/cruise-search-mask/cruise-search-mask.style.tsx



var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var assetPrefix = (0,buildVersion/* getAssetsPrefix */.x)();
var StyledContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1gbckpr17"
} : 0)("width:100%;height:100%;max-height:425px;background-color:", function (props) {
  return props.theme.colors['main1-50'];
}, ";@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{width:550px;margin:", function (props) {
  return props.margin;
}, ";height:auto;max-height:auto;background-color:rgba(0, 35, 59, 0.6);}@media ", global_style/* mediaQueries.desktopAndUp */.w5.desktopAndUp, "{height:100%;max-height:640px;margin:0;display:flex;flex-direction:column;justify-content:space-around;width:550px;background-color:rgba(0, 35, 59, 0.5);}@media screen and (-ms-high-contrast: active),(-ms-high-contrast: none){max-height:100%;}" + ( true ? "" : 0));
var StyledSelectWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1gbckpr16"
} : 0)("display:flex;flex-direction:column;", global_style/* media.tablet */.BC.tablet(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n        flex-direction: row;\n    "]))), " &>div{flex:1;margin-bottom:10px;", global_style/* media.tablet */.BC.tablet(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n            width: 50%;\n            margin-right: 10px;\n        "]))), " &:last-child{margin-right:0;}}" + ( true ? "" : 0));
var StyledInnerContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1gbckpr15"
} : 0)("padding-left:16px;padding-right:16px;margin:0 auto;max-height:425px;display:flex;flex-direction:column;justify-content:center;", global_style/* media.tablet */.BC.tablet(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n      padding: 50px 30px 0 30px;\n    "]))), " ", global_style/* media.desktop */.BC.desktop(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n        padding-top: 40px;\n        width: 500px;\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n    "]))), ";" + ( true ? "" : 0));
var StyledHeadlineInner = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1gbckpr14"
} : 0)("@media ", global_style/* mediaQueries.phone */.w5.phone, "{display:block;text-shadow:0 0 4px ", function (props) {
  return props.theme.dropShadows['black-50'];
}, ";color:", function (props) {
  return props.theme.shades.white;
}, ";padding-top:0;margin-left:-16px;margin-right:-16px;}@media ", global_style/* mediaQueries.desktopAndUp */.w5.desktopAndUp, "{display:block;text-shadow:0 0 4px ", function (props) {
  return props.theme.dropShadows['black-50'];
}, ";color:", function (props) {
  return props.theme.shades.white;
}, ";padding-top:20px;}" + ( true ? "" : 0));
var ButtonStyled = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(dreamlines_button/* DreamlinesButton */.P,  true ? {
  target: "e1gbckpr13"
} : 0)("width:100%;position:relative;cursor:pointer;padding-left:20px;padding-right:40px;@media ", global_style/* mediaQueries.allMobileDevices */.w5.allMobileDevices, "{height:auto;}" + ( true ? "" : 0));
var ButtonText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1gbckpr12"
} : 0)( true ? {
  name: "hh9iz5",
  styles: "padding:0!important;white-space:initial;>span{padding:0!important;}"
} : 0);
var StyledPreHeadline = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1gbckpr11"
} : 0)("font-weight:400;font-size:19px;display:block;", global_style/* media.smallDesktop */.BC.smallDesktop(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n        font-size: 16px;\n        font-weight: 400;\n    "]))), ";" + ( true ? "" : 0));
var StyledHeadline = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h1",  true ? {
  target: "e1gbckpr10"
} : 0)("font-size:30px;line-height:39px;padding-top:24px;margin-top:0;margin-bottom:20px;@media ", global_style/* mediaQueries.allDesktop */.w5.allDesktop, "{font-size:38px;line-height:40px;font-weight:600;letter-spacing:normal;padding-left:0;padding-top:4px;margin-bottom:50px;text-shadow:0 0 6px ", function (props) {
  return props.theme.dropShadows['black-50'];
}, ";}" + ( true ? "" : 0));
var StyledHeadlineOutside = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1gbckpr9"
} : 0)("display:none;@media ", global_style/* mediaQueries.tablet */.w5.tablet, "{display:block;font-size:57px;padding-top:25px;text-align:center;font-weight:600;line-height:1.5;text-shadow:0 0 6px ", function (props) {
  return props.theme.dropShadows['black-50'];
}, ";padding-left:", function (props) {
  return props.theme.spacingX.mobile;
}, ";margin-bottom:30px;margin-top:0;color:", function (props) {
  return props.theme.shades.white;
}, ";span{font-size:20px;display:block;}}@media ", global_style/* mediaQueries.smallDesktop */.w5.smallDesktop, "{display:block;font-size:57px;padding-top:25px;text-align:center;font-weight:600;line-height:1.5;text-shadow:0 0 6px ", function (props) {
  return props.theme.dropShadows['black-50'];
}, ";padding-left:", function (props) {
  return props.theme.spacingX.mobile;
}, ";margin-bottom:30px;margin-top:0;color:", function (props) {
  return props.theme.shades.white;
}, ";span{font-size:20px;display:block;}}" + ( true ? "" : 0));
var StyledIconWithTextWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1gbckpr8"
} : 0)( true ? {
  name: "zjik7",
  styles: "display:flex"
} : 0);
var StyledDesktopBagdeContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1gbckpr7"
} : 0)("display:none;@media ", global_style/* mediaQueries.desktopAndUp */.w5.desktopAndUp, "{border-top:1px solid ", function (props) {
  return props.theme.shades.lightGrey;
}, ";padding-top:10px;padding-bottom:10px;margin:40px auto 0 auto;width:550px;display:flex;justify-content:space-around;align-items:center;font-size:12px;font-weight:400px;& span{padding-left:10px;width:140px;display:flex;align-self:center;}}" + ( true ? "" : 0));
var StyledUspContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1gbckpr6"
} : 0)("width:100%;display:flex;align-items:center;justify-content:center;padding-top:20px;padding-bottom:10px;", global_style/* media.tablet */.BC.tablet(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n      padding: 40px 5px 20px 5px;\n      justify-content: space-between;\n    "]))), " ", global_style/* media.smallDesktop */.BC.smallDesktop(_templateObject7 || (_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n      padding-top: 20px;\n    "]))), " span{font-weight:600;font-size:16px;margin-left:3px;color:", function (props) {
  return props.theme.shades.white;
}, ";", global_style/* media.tablet */.BC.tablet(_templateObject8 || (_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n          font-size: 13px;\n      "]))), ";}" + ( true ? "" : 0));
var StyledWinner = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(winner,  true ? {
  target: "e1gbckpr5"
} : 0)("fill:", function (props) {
  return props.theme.shades.white;
}, ";width:26px;height:26px;" + ( true ? "" : 0));
var StyledThumbsUp = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(thumbsUp/* default */.Z,  true ? {
  target: "e1gbckpr4"
} : 0)("fill:", function (props) {
  return props.theme.shades.white;
}, ";width:18px;height:18px;margin-right:3px;" + ( true ? "" : 0));
var StyledDreamlinesPackageExpert = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(dreamlinesPackage_expert,  true ? {
  target: "e1gbckpr3"
} : 0)("fill:", function (props) {
  return props.theme.shades.white;
}, ";width:21px;height:21px;margin-right:3px;" + ( true ? "" : 0));
var StyledSsl = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1gbckpr2"
} : 0)("width:50px;height:47px;background-size:contain;background-repeat:no-repeat;background-image:url('", assetPrefix, "/static/SSL_security.svg');" + ( true ? "" : 0));
var StyledBestPrice = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1gbckpr1"
} : 0)("width:35px;height:49px;background-size:contain;background-repeat:no-repeat;background-image:url('", assetPrefix, "/static/bestprice_badge.svg');" + ( true ? "" : 0));
var StyledLabel = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("label",  true ? {
  target: "e1gbckpr0"
} : 0)((0,global_style/* visuallyHidden */.jy)(), ";" + ( true ? "" : 0));

/***/ }),

/***/ 1544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ CruiseSearchMask; },
  "j": function() { return /* binding */ dateTypeEventMap; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 3 modules
var emotion_styled_base_browser_esm = __webpack_require__(61516);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/getUnixTime/index.js + 1 modules
var getUnixTime = __webpack_require__(28401);
// EXTERNAL MODULE: ./src/contexts/device/device.tsx
var device_device = __webpack_require__(90780);
// EXTERNAL MODULE: ./src/contexts/locale-config/locale-config.tsx
var locale_config = __webpack_require__(36097);
// EXTERNAL MODULE: ./src/utils/device-detection.ts
var device_detection = __webpack_require__(52756);
// EXTERNAL MODULE: ./src/utils/EventTracker.ts
var EventTracker = __webpack_require__(6946);
// EXTERNAL MODULE: ./src/utils/translation-service.ts
var translation_service = __webpack_require__(21449);
// EXTERNAL MODULE: ./src/components/atoms/dreamlines-button/dreamlines-button.tsx
var dreamlines_button = __webpack_require__(2730);
// EXTERNAL MODULE: ./src/components/molecules/search-dropdown/search-dropdown.tsx
var search_dropdown = __webpack_require__(86057);
// EXTERNAL MODULE: ./src/components/molecules/calendar-modal/calendar-modal.tsx + 6 modules
var calendar_modal = __webpack_require__(39795);
// EXTERNAL MODULE: ./node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(98396);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./src/components/atoms/breadcrumbs/breadcrumbs.tsx
var breadcrumbs = __webpack_require__(86724);
// EXTERNAL MODULE: ./src/components/atoms/back-button/back-button.tsx + 1 modules
var back_button = __webpack_require__(55029);
// EXTERNAL MODULE: ./src/components/atoms/arrow/arrow.tsx + 1 modules
var arrow = __webpack_require__(5966);
;// CONCATENATED MODULE: ./src/components/molecules/landing-breadcrumbs/landing-breadcrumbs.style.tsx

var StyledBackButtonContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e110gx6d0"
} : 0)("display:flex;justify-content:left;padding:8px 21px;background-color:", function (props) {
  return props.theme.colorsUnifications.white[100];
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ./src/components/sections/landing-breadcrumbs/landing-breadcrumbs.tsx
var landing_breadcrumbs = __webpack_require__(92885);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./src/components/molecules/landing-breadcrumbs/landing-breadcrumbs.tsx










var LandingBreadcrumbs = function LandingBreadcrumbs(_ref) {
  var pageProps = _ref.pageProps;
  var localeConfig = react.useContext(locale_config/* LocaleConfigContext */.nO);
  var modulesData = pageProps === null || pageProps === void 0 ? void 0 : pageProps.modulesData;
  var landingPage = pageProps === null || pageProps === void 0 ? void 0 : pageProps.getLandingPage;
  var paths = (0,landing_breadcrumbs/* getBreadcrumbsPath */.bp)(landingPage, modulesData, localeConfig);
  var theme = (0,useTheme/* default */.Z)();
  var isMobileView = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down('sm'));
  var lastPath = paths.slice(-2, -1)[0];
  return isMobileView ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledBackButtonContainer, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(back_button/* BackButton */.x, {
      href: lastPath.url,
      children: lastPath.title
    })
  }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(breadcrumbs/* Breadcrumbs */.O, {
    paths: paths,
    variant: "light",
    separator: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(arrow/* Arrow */.E, {
      size: "S",
      orientation: "right",
      style: {
        fill: 'white'
      }
    })
  });
};
// EXTERNAL MODULE: ./src/components/molecules/calendar/calendar.tsx + 1 modules
var calendar = __webpack_require__(58306);
// EXTERNAL MODULE: ./src/components/molecules/cruise-search-mask/cruise-search-mask.style.tsx + 2 modules
var cruise_search_mask_style = __webpack_require__(62372);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
;// CONCATENATED MODULE: ./src/components/molecules/cruise-search-mask/reducer.ts



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function reducer(state, action) {
  switch (action.type) {
    case 'SELECT_ITEM':
      var selected = action.selected,
          selectedItem = action.selectedItem;
      return _objectSpread(_objectSpread(_objectSpread({}, state), selected === 'region' ? {
        selectedRegion: selectedItem
      } : selected === 'ship' ? {
        selectedShip: selectedItem
      } : {
        selectedBrand: selectedItem
      }), {}, {
        isLoading: true
      });

    case 'SELECT_DATES':
      return _objectSpread(_objectSpread({}, state), {}, {
        startDate: action.selectedDates.startDate || null,
        endDate: action.selectedDates.endDate || null,
        isLoading: true
      });

    case 'RESET_FILTERS':
      return _objectSpread(_objectSpread({}, action.defaultState), {}, {
        isLoading: true
      });

    case 'SELECT_WITH_FLIGHTS':
      return _objectSpread(_objectSpread({}, state), {}, {
        withFlights: action.selected,
        isLoading: true
      });

    case 'RECEIVE_DATA':
      if (!action.data.totalCount) {
        var selectedBrand = state.selectedBrand,
            selectedRegion = state.selectedRegion,
            selectedShip = state.selectedShip;
        return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, state), action.data), selectedBrand && {
          brandItems: {
            top: [],
            all: [_objectSpread(_objectSpread({}, selectedBrand), {}, {
              count: 0
            })]
          }
        }), selectedRegion && {
          regionItems: {
            top: [],
            all: [_objectSpread(_objectSpread({}, selectedRegion), {}, {
              count: 0
            })]
          }
        }), selectedShip && {
          shipItems: {
            top: [],
            all: [_objectSpread(_objectSpread({}, selectedShip), {}, {
              count: 0
            })]
          }
        }), {}, {
          selectedBrand: selectedBrand ? _objectSpread(_objectSpread({}, selectedBrand), {}, {
            count: 0
          }) : null,
          selectedRegion: selectedRegion ? _objectSpread(_objectSpread({}, selectedRegion), {}, {
            count: 0
          }) : null,
          selectedShip: selectedShip ? _objectSpread(_objectSpread({}, selectedShip), {}, {
            count: 0
          }) : null,
          isLoading: false
        });
      } else {
        var _action$data = action.data,
            brandItems = _action$data.brandItems,
            regionItems = _action$data.regionItems,
            shipItems = _action$data.shipItems,
            totalCount = _action$data.totalCount,
            withFlights = _action$data.withFlights;
        var _selectedBrand = state.selectedBrand,
            _selectedRegion = state.selectedRegion,
            _selectedShip = state.selectedShip;
        var newSelectedBrand = brandItems.all.find(function (_ref) {
          var key = _ref.key;
          return (_selectedBrand === null || _selectedBrand === void 0 ? void 0 : _selectedBrand.key) === key;
        }) || null;
        var newSelectedRegion = regionItems.all.find(function (_ref2) {
          var key = _ref2.key;
          return (_selectedRegion === null || _selectedRegion === void 0 ? void 0 : _selectedRegion.key) === key;
        }) || null;
        var newSelectedShip = shipItems.all.find(function (_ref3) {
          var key = _ref3.key;
          return (_selectedShip === null || _selectedShip === void 0 ? void 0 : _selectedShip.key) === key;
        }) || null;
        var isSelectedBrandAbsentFromResult = !newSelectedBrand && _selectedBrand;
        var isSelectedRegionAbsentFromResult = !newSelectedRegion && _selectedRegion;
        var isSelectedShipAbsentFromResult = !newSelectedShip && _selectedShip;
        var allBrands = isSelectedBrandAbsentFromResult ? [].concat((0,toConsumableArray/* default */.Z)(brandItems.all), [_objectSpread(_objectSpread({}, _selectedBrand), {}, {
          count: 0
        })]) : brandItems.all;
        var allRegions = isSelectedRegionAbsentFromResult ? [].concat((0,toConsumableArray/* default */.Z)(regionItems.all), [_objectSpread(_objectSpread({}, _selectedRegion), {}, {
          count: 0
        })]) : regionItems.all;
        var allShips = isSelectedShipAbsentFromResult ? [].concat((0,toConsumableArray/* default */.Z)(shipItems.all), [_objectSpread(_objectSpread({}, _selectedShip), {}, {
          count: 0
        })]) : shipItems.all;
        return _objectSpread(_objectSpread({}, state), {}, {
          totalCount: totalCount,
          withFlights: withFlights,
          regionItems: _objectSpread(_objectSpread({}, regionItems), {}, {
            all: allRegions
          }),
          brandItems: _objectSpread(_objectSpread({}, brandItems), {}, {
            all: allBrands
          }),
          shipItems: _objectSpread(_objectSpread({}, shipItems), {}, {
            all: allShips
          }),
          selectedBrand: isSelectedBrandAbsentFromResult ? _objectSpread(_objectSpread({}, _selectedBrand), {}, {
            count: 0
          }) : newSelectedBrand,
          selectedRegion: isSelectedRegionAbsentFromResult ? _objectSpread(_objectSpread({}, _selectedRegion), {}, {
            count: 0
          }) : newSelectedRegion,
          selectedShip: isSelectedShipAbsentFromResult ? _objectSpread(_objectSpread({}, _selectedShip), {}, {
            count: 0
          }) : newSelectedShip,
          isLoading: false
        });
      }

    default:
      var _exhaustiveCheck = action;
      return _exhaustiveCheck;
  }
}
// EXTERNAL MODULE: ./src/components/molecules/cruise-search-mask/utils.ts + 1 modules
var utils = __webpack_require__(47156);
// EXTERNAL MODULE: ./src/api/resources.ts
var resources = __webpack_require__(15206);
// EXTERNAL MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(66489);
;// CONCATENATED MODULE: ./src/components/molecules/cruise-search-mask/cruise-search-mask.tsx



function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






















var keys = ['brandSearchHeadline', 'regionSearchHeadline', 'brandSelectAll', 'regionSelectAll', 'shipSelectAll', 'searchPlaceHolder', 'searchMaskUSP1', 'searchMaskUSP2', 'searchMaskUSP3', 'weGuaranteeYouTheBestPrice', 'yourDataIsSafeWithUs', 'showOffersCTA'];
translation_service/* TranslationService.registerKeys */.D.registerKeys(keys);

var StyledSearchButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(dreamlines_button/* DreamlinesButton */.P,  true ? {
  target: "e1f96ctx0"
} : 0)( true ? {
  name: "1g4o9fb",
  styles: "&&{span:first-child{padding:0;}}"
} : 0);

var getFacetsData = function getFacetsData(payload) {
  return (0,resources/* searchCruiseFacets */.lP)(payload).then(function (resp) {
    var data = (0,utils/* transformFacetsData */.N2)(resp);
    return data;
  }).catch(function (err) {
    console.error('Unable to retreive cruise information');
    return null;
  });
};

var dateTypeEventMap = {
  startDate: 'calendar_departure',
  endDate: 'calendar_arrival'
};
var CruiseSearchMask = function CruiseSearchMask(_ref) {
  var _facetItems$shipItems3;

  var preHeadline = _ref.preHeadline,
      type = _ref.type,
      headline = _ref.headline,
      showBadge = _ref.showBadge,
      _ref$showUSP = _ref.showUSP,
      showUSP = _ref$showUSP === void 0 ? true : _ref$showUSP,
      containerMargin = _ref.containerMargin,
      cruiseSearchFacets = _ref.cruiseSearchFacets,
      pageTypeId = _ref.pageTypeId,
      pageProps = _ref.pageProps;
  var device = react.useContext(device_device/* DeviceContext */.Tp);
  var localeConfig = react.useContext(locale_config/* LocaleConfigContext */.nO);
  var facetItems = (0,utils/* transformFacetsData */.N2)(cruiseSearchFacets);
  var currentShipItem = react.useMemo(function () {
    var _facetItems$shipItems, _facetItems$shipItems2;

    if (!(facetItems !== null && facetItems !== void 0 && (_facetItems$shipItems = facetItems.shipItems) !== null && _facetItems$shipItems !== void 0 && (_facetItems$shipItems2 = _facetItems$shipItems.all) !== null && _facetItems$shipItems2 !== void 0 && _facetItems$shipItems2.length)) {
      return null;
    }

    return facetItems.shipItems.all.find(function (item) {
      return Number(item.key) === pageTypeId;
    }) || null;
  }, [(_facetItems$shipItems3 = facetItems.shipItems) === null || _facetItems$shipItems3 === void 0 ? void 0 : _facetItems$shipItems3.all]);
  var initialState = {
    regionItems: {
      top: facetItems.regionItems.top || [],
      all: facetItems.regionItems.all || []
    },
    brandItems: {
      top: facetItems.brandItems.top || [],
      all: facetItems.brandItems.all || []
    },
    shipItems: {
      top: facetItems.shipItems.top || [],
      all: facetItems.shipItems.all || []
    },
    startDate: null,
    endDate: null,
    selectedRegion: null,
    selectedBrand: null,
    selectedShip: currentShipItem,
    totalCount: null,
    isLoading: false
  };
  react.useEffect(function () {
    dispatch({
      type: 'SELECT_ITEM',
      selected: 'ship',
      selectedItem: initialState.selectedShip
    });
    dispatch({
      type: 'RECEIVE_DATA',
      data: facetItems
    });
  }, [cruiseSearchFacets]);

  var _React$useReducer = react.useReducer(reducer, initialState),
      _React$useReducer2 = (0,slicedToArray/* default */.Z)(_React$useReducer, 2),
      state = _React$useReducer2[0],
      dispatch = _React$useReducer2[1];

  var regionItems = state.regionItems,
      startDate = state.startDate,
      endDate = state.endDate,
      selectedRegion = state.selectedRegion,
      selectedBrand = state.selectedBrand,
      selectedShip = state.selectedShip,
      totalCount = state.totalCount,
      isLoading = state.isLoading,
      shipItems = state.shipItems;
  var selectedData = {
    region: selectedRegion,
    brand: selectedBrand,
    ship: selectedShip,
    startDate: startDate || null,
    endDate: endDate || null
  };
  var searchButtonUrl = (0,utils/* createSearchUrl */.nM)("/".concat(localeConfig.slugs.search), selectedData);

  var submit = function submit() {
    var eventLabel = (0,utils/* generateEventLabel */.lv)(selectedData);
    EventTracker/* eventTracker.track */.xT.track({
      event: 'click',
      label: eventLabel,
      action: 'search-button',
      category: "cruise-search-mask-".concat(type, "page")
    });
  };

  var handleDatesChange = function handleDatesChange(_ref2) {
    var startDate = _ref2.startDate,
        endDate = _ref2.endDate,
        typeOfDate = _ref2.typeOfDate;

    if (typeOfDate && (startDate || endDate)) {
      EventTracker/* eventTracker.ga4Track */.xT.ga4Track('search_filters', {
        page_type: 'Ship Landing Page',
        event_type: dateTypeEventMap[typeOfDate]
      });
    }

    dispatch({
      type: 'SELECT_DATES',
      selectedDates: {
        startDate: startDate,
        endDate: endDate
      }
    });
    getFacetsData({
      shipId: (selectedShip === null || selectedShip === void 0 ? void 0 : selectedShip.key) || pageTypeId,
      startDate: startDate ? (0,getUnixTime/* default */.Z)(startDate) : undefined,
      endDate: endDate ? (0,getUnixTime/* default */.Z)(endDate) : undefined,
      zoneId: selectedRegion === null || selectedRegion === void 0 ? void 0 : selectedRegion.key
    }).then(function (data) {
      if (data) {
        dispatch({
          type: 'RECEIVE_DATA',
          data: data
        });
      }
    });
  };

  var handleItemChange = function handleItemChange(item, type) {
    var selectedItem = item !== null && item !== void 0 && item.key ? item : null;
    dispatch({
      type: 'SELECT_ITEM',
      selected: type,
      selectedItem: selectedItem
    });
    var zoneId = type === 'region' ? item === null || item === void 0 ? void 0 : item.key : selectedRegion === null || selectedRegion === void 0 ? void 0 : selectedRegion.key;
    var shipId = type === 'ship' ? item === null || item === void 0 ? void 0 : item.key : selectedShip === null || selectedShip === void 0 ? void 0 : selectedShip.key;
    getFacetsData({
      shipId: shipId || pageTypeId,
      startDate: startDate ? (0,getUnixTime/* default */.Z)(startDate) : undefined,
      endDate: endDate ? (0,getUnixTime/* default */.Z)(endDate) : undefined,
      zoneId: zoneId
    }).then(function (data) {
      if (data) {
        dispatch({
          type: 'RECEIVE_DATA',
          data: data
        });
      }
    });
  };

  var isMobile = device === 'mobile';
  var isDesktop = device === 'desktop';
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cruise_search_mask_style/* StyledContainer */.PQ, {
      "data-testid": "cruise-search-mask-container",
      margin: containerMargin,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cruise_search_mask_style/* StyledInnerContainer */.fP, {
        "data-testid": "cruise-search-mask-inner-container",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cruise_search_mask_style/* StyledHeadlineInner */.Le, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LandingBreadcrumbs, {
            pageProps: pageProps
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cruise_search_mask_style/* StyledPreHeadline */.wl, {
            children: preHeadline
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cruise_search_mask_style/* StyledHeadline */.yF, {
            children: headline
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("form", {
            onSubmit: function onSubmit(e) {
              return e.preventDefault();
            },
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cruise_search_mask_style/* StyledLabel */.ar, {
              children: "Search Cruise"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cruise_search_mask_style/* StyledSelectWrapper */.W6, {
              children: [type !== 'destination' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(search_dropdown/* SearchDropdown */.E, {
                onSelectHandler: function onSelectHandler(val) {
                  return handleItemChange(val, 'region');
                },
                items: regionItems,
                heading: (0,translation_service.__)('regionSearchHeadline'),
                selectAllText: (0,translation_service.__)('regionSelectAll'),
                placeholder: (0,translation_service.__)('searchPlaceHolder'),
                selectedItem: selectedRegion,
                withModal: (0,device_detection/* getDetectedDevice */.c)() === 'mobile'
              }), type !== 'ship' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(search_dropdown/* SearchDropdown */.E, {
                onSelectHandler: function onSelectHandler(val) {
                  return handleItemChange(val, 'ship');
                },
                items: shipItems,
                placeholder: (0,translation_service.__)('searchPlaceHolder'),
                heading: (0,translation_service.__)('shipSelectAll'),
                selectAllText: (0,translation_service.__)('shipSelectAll'),
                selectedItem: selectedShip,
                withModal: (0,device_detection/* getDetectedDevice */.c)() === 'mobile'
              })]
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              style: {
                width: '100%',
                marginBottom: '10px'
              },
              children: isMobile ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(calendar_modal/* CalendarModal */.D, {
                onDateChange: handleDatesChange
              }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(calendar/* default */.Z, {
                onDateChange: handleDatesChange
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSearchButton, {
              disabled: isLoading,
              onClick: submit,
              style: {
                width: '100%',
                marginTop: 10,
                height: 55,
                position: 'relative',
                cursor: 'pointer'
              },
              wrapperStyle: {
                width: '100%'
              },
              domType: "a",
              redirectUrl: searchButtonUrl,
              children: [!!totalCount && !isLoading && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                style: {
                  padding: '0'
                },
                children: totalCount
              }), "\xA0", isLoading && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CircularProgress/* default */.Z, {
                thickness: 6,
                size: 18,
                sx: {
                  color: '#fff',
                  marginRight: '6px'
                }
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                children: (0,translation_service.__)('showOffersCTA')
              })]
            })]
          }), !isMobile && (showUSP || isDesktop) && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cruise_search_mask_style/* StyledUspContainer */.mO, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cruise_search_mask_style/* StyledIconWithTextWrapper */.QN, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cruise_search_mask_style/* StyledThumbsUp */.UJ, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                children: (0,translation_service.__)('searchMaskUSP2')
              })]
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cruise_search_mask_style/* StyledIconWithTextWrapper */.QN, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cruise_search_mask_style/* StyledDreamlinesPackageExpert */.R9, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                children: (0,translation_service.__)('searchMaskUSP3')
              })]
            })]
          }), showUSP && isMobile && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cruise_search_mask_style/* StyledUspContainer */.mO, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cruise_search_mask_style/* StyledWinner */.I7, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
              children: (0,translation_service.__)('searchMaskUSP1')
            })]
          })]
        })]
      }), showBadge ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cruise_search_mask_style/* StyledDesktopBagdeContainer */.cF, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cruise_search_mask_style/* StyledIconWithTextWrapper */.QN, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cruise_search_mask_style/* StyledBestPrice */.BN, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            children: (0,translation_service.__)('weGuaranteeYouTheBestPrice')
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cruise_search_mask_style/* StyledIconWithTextWrapper */.QN, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cruise_search_mask_style/* StyledSsl */.R6, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            children: (0,translation_service.__)('yourDataIsSafeWithUs')
          })]
        })]
      }) : // We always want an element to keep the search aligned
      (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {})]
    })
  });
};

/***/ }),

/***/ 52753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ Modal; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 3 modules
var emotion_styled_base_browser_esm = __webpack_require__(61516);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./src/style/global-style.tsx
var global_style = __webpack_require__(43780);
// EXTERNAL MODULE: ./public/static/arrow_back.svg
var arrow_back = __webpack_require__(72409);
;// CONCATENATED MODULE: ./src/components/molecules/modal/modal.style.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



var _ref2 =  true ? {
  name: "1isadng",
  styles: "transform:translate3d(0, 0, 0)"
} : 0;

var _ref3 =  true ? {
  name: "1hcx8jb",
  styles: "padding:0"
} : 0;

var StyledModalWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1hcmvia5"
} : 0)("background:", function (props) {
  return props.theme.shades.white;
}, ";transition:", function (props) {
  return "all ".concat(props.transitionDuration, "ms ease");
}, ";position:fixed;z-index:999;width:100%;height:100%;top:0;transform:translate3d(100%, 0, 0);padding:12px;>div{height:100%;}", function (props) {
  return props.fullWidthContent && _ref3;
}, " ", function (props) {
  return props.showModal && _ref2;
}, ";" + ( true ? "" : 0));
var StyledModalBodyWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1hcmvia4"
} : 0)( true ? {
  name: "16ql1ex",
  styles: "padding:20px 0 0;height:100%"
} : 0);

var _ref =  true ? {
  name: "18637is",
  styles: "padding:12px 0 0 12px"
} : 0;

var StyledModalHeaderWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1hcmvia3"
} : 0)("display:flex;justify-content:space-between;margin-top:5px;color:", function (props) {
  return props.theme.shades.blackGrey;
}, ";", function (props) {
  return props.fullWidthContent && _ref;
}, ";" + ( true ? "" : 0));
var StyledModalHeaderHeadline = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h3",  true ? {
  target: "e1hcmvia2"
} : 0)( true ? {
  name: "1x1zmka",
  styles: "font-size:20px;line-height:1.2;margin:0;font-weight:500;width:100%;text-align:center"
} : 0);
var StyledModalHeaderBackButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "e1hcmvia1"
} : 0)( true ? {
  name: "f0y2d5",
  styles: "outline:none;background:none;padding-left:0;border:0"
} : 0);
var StyledModalHeaderRightIcon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1hcmvia0"
} : 0)("color:", function (props) {
  return props.theme.colors.main4;
}, ";&,&>*{font-size:11px!important;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./src/components/molecules/modal/modal.tsx










var StyledArrow = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(arrow_back/* default */.Z,  true ? {
  target: "e1y84s6u0"
} : 0)("fill:", function (props) {
  return props.theme.shades.grey6;
}, ";width:22px;height:17px;" + ( true ? "" : 0));

var Modal = function Modal(props) {
  var showModal = props.showModal,
      onClose = props.onClose,
      headerText = props.headerText,
      onOpen = props.onOpen,
      timeout = props.timeout,
      fullWidthContent = props.fullWidthContent;

  var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      _showModal = _React$useState2[0],
      _setShowModal = _React$useState2[1];

  var _React$useState3 = react.useState(null),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      targetNode = _React$useState4[0],
      setTargetNode = _React$useState4[1];

  var onCloseHandler = function onCloseHandler() {
    _setShowModal(false);

    if (onClose) {
      document.body.style.overflow = 'auto';
      onClose();
    }
  };

  react.useEffect(function () {
    _setShowModal(showModal);
  }, [showModal]);
  react.useEffect(function () {
    showModal && onOpen && setTimeout(function () {
      return onOpen();
    }, timeout); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModal]);
  /*Setting the targetNode to modal after component mounting to avoid server side
  inaccessibility of document node. */

  react.useEffect(function () {
    setTargetNode(document.getElementById('modal'));
  }, []); // Checking window object at client side since document object is not accessible on ssr

  if (true) {
    if (_showModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }

  return targetNode && /*#__PURE__*/react_dom.createPortal((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledModalWrapper, {
    showModal: _showModal,
    role: "dialog",
    "aria-hidden": !_showModal,
    "data-testid": props['data-testid'] || 'modal',
    transitionDuration: props.timeout || global_style/* theme.transition.duration.modal */.rS.transition.duration.modal,
    fullWidthContent: fullWidthContent,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      "data-testid": "modal-content",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledModalHeaderWrapper, {
        fullWidthContent: fullWidthContent,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledModalHeaderBackButton, {
          onClick: onCloseHandler,
          "data-testid": "modal-close-btn",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledArrow, {})
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledModalHeaderHeadline, {
          children: headerText
        }), props.rightIcon ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledModalHeaderRightIcon, {
          children: props.rightIcon
        }) : null]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledModalBodyWrapper, {
        className: "modal-body",
        "data-testid": "modal-body",
        children: props.children
      })]
    })
  }), targetNode);
};
Modal.defaultProps = {
  timeout: 400
};

/***/ }),

/***/ 69280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e0": function() { return /* binding */ ArrowIcon; },
  "JO": function() { return /* binding */ Icon; },
  "Ep": function() { return /* binding */ RightControllerButton; },
  "W1": function() { return /* binding */ SearchIcon; },
  "Fy": function() { return /* binding */ StyledInput; },
  "SD": function() { return /* binding */ StyledWrapper; },
  "b0": function() { return /* binding */ XIcon; }
});

// UNUSED EXPORTS: ControllerButton

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 3 modules
var emotion_styled_base_browser_esm = __webpack_require__(61516);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./public/static/search.svg
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 50 50"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M49.24 45.542 36.914 33.165c3.17-3.637 4.906-8.213 4.906-12.978C41.82 9.057 32.44 0 20.91 0S0 9.056 0 20.187C0 31.32 9.38 40.375 20.91 40.375c4.328 0 8.453-1.26 11.98-3.653l12.419 12.47c.519.521 1.217.808 1.965.808.708 0 1.38-.26 1.89-.735a2.572 2.572 0 0 0 .076-3.723ZM20.91 5.266c8.522 0 15.455 6.694 15.455 14.921 0 8.228-6.933 14.922-15.455 14.922S5.455 28.415 5.455 20.187c0-8.227 6.933-14.92 15.455-14.92Z"
  })));
};

/* harmony default export */ var search = (SvgSearch);
// EXTERNAL MODULE: ./public/static/arrow.svg
var arrow = __webpack_require__(59846);
;// CONCATENATED MODULE: ./public/static/x_icon.svg
var x_icon_path;

function x_icon_extends() { x_icon_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return x_icon_extends.apply(this, arguments); }



var SvgXIcon = function SvgXIcon(props) {
  return /*#__PURE__*/react.createElement("svg", x_icon_extends({
    viewBox: "0 0 20 20",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), x_icon_path || (x_icon_path = /*#__PURE__*/react.createElement("path", {
    d: "m1 1 18 18M19 1 1 19"
  })));
};

/* harmony default export */ var x_icon = (SvgXIcon);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./src/components/molecules/search-dropdown/search-dropdown.style.tsx



var _excluded = ["isOpen"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var StyledWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1oozew77"
} : 0)( true ? {
  name: "1euuqs0",
  styles: "position:relative;display:flex;@media screen and (-ms-high-contrast: active),(-ms-high-contrast: none){display:block;}"
} : 0);
var ControllerButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "e1oozew76"
} : 0)( true ? {
  name: "nni0rc",
  styles: "background-color:transparent;border:none;position:absolute;top:1px;cursor:pointer;width:47px;display:flex;flex-direction:column;height:100%;justify-content:center;align-items:center;padding-right:5px"
} : 0);
var RightControllerButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ControllerButton,  true ? {
  target: "e1oozew75"
} : 0)( true ? {
  name: "1wf8jf",
  styles: "right:0"
} : 0);
var Icon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1oozew74"
} : 0)("fill:", function (props) {
  return props.theme.shades.blackGrey;
}, ";height:32px;position:absolute;top:9px;left:0px;border-right:1px solid ", function (props) {
  return props.theme.colors.black;
}, ";padding:0 12.5px;margin-right:11px;" + ( true ? "" : 0));
// @TODO: Using downshift's props in styled components forces the fonts to be refetched and reloaded
// causing a flash on the page. This happens for every styled component that takes a downshift prop
// as an argument. This behaviour is observed only in the DEV mode.
var ArrowIcon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(function (_ref) {
  var isOpen = _ref.isOpen,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(arrow/* default */.Z, _objectSpread({}, rest));
},  true ? {
  target: "e1oozew73"
} : 0)("width:14px;height:14px;stroke-width:2;fill:", function (props) {
  return props.theme.shades.darkGrey;
}, ";transform:", function (props) {
  return props.isOpen ? "rotate(-90deg)" : "rotate(90deg)";
}, ";" + ( true ? "" : 0));
var SearchIcon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(search,  true ? {
  target: "e1oozew72"
} : 0)( true ? {
  name: "n3on53",
  styles: "margin-top:3.5px;width:25px"
} : 0);
var XIcon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(x_icon,  true ? {
  target: "e1oozew71"
} : 0)("width:15px;height:15px;stroke-width:2;stroke:", function (props) {
  return props.theme.shades.darkGrey;
}, ";" + ( true ? "" : 0));
var StyledInput = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("input",  true ? {
  target: "e1oozew70"
} : 0)("height:45px;width:100%;padding-left:13px;padding-right:36px;font-size:", function (props) {
  return props.theme.fontSize.regularS;
}, ";border-style:none;border-radius:0;background:", function (props) {
  return props.theme.shades.white;
}, ";color:", function (props) {
  return props.theme.shades.blackGrey;
}, ";&:focus{opacity:1;}" + ( true ? "" : 0));

/***/ }),

/***/ 86057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ SearchDropdown; }
/* harmony export */ });
/* harmony import */ var _app_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var downshift__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53680);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






/**
 * This is being done because for integration tests, these imports
 * are immediately needed and thus mocking out dynamic won't work.
 * Dynamic isn't working correctly with jest as it doesn't recognize this.
 * There are two babel transpilers (dynamic-import-node and transform-dynamic-import)
 * for this but there was some issue with both of them.
 *
 * @TODO Use a babel transpiler for dynamic and mock the correct file in the tests.
 * Look into this issue for more help: https://github.com/zeit/next.js/issues/5416
 * There is a library for doing the whole thing but there was some issue with the
 * transpiler still: https://github.com/FormidableLabs/jest-next-dynamic
 */
var MobileSelect =  false ? 0 : next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return __webpack_require__.e(/* import() */ 4704).then(__webpack_require__.bind(__webpack_require__, 84704));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(84704)];
    }
  }
});
var DesktopSelect =  false ? 0 : next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return __webpack_require__.e(/* import() */ 4970).then(__webpack_require__.bind(__webpack_require__, 94970));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(94970)];
    }
  }
});
var SearchDropdown = function SearchDropdown(props) {
  var Select = props.withModal ? MobileSelect : DesktopSelect;

  var stateReducer = function stateReducer(_state, changes) {
    //set inputValue as empty when the submenu is open and there is no change type found.
    if (changes.isOpen && !changes.type) {
      return _objectSpread(_objectSpread({}, changes), {}, {
        inputValue: ''
      });
    }

    switch (changes.type) {
      case downshift__WEBPACK_IMPORTED_MODULE_3__/* ["default"].stateChangeTypes.controlledPropUpdatedSelectedItem */ .ZP.stateChangeTypes.controlledPropUpdatedSelectedItem:
      case downshift__WEBPACK_IMPORTED_MODULE_3__/* ["default"].stateChangeTypes.mouseUp */ .ZP.stateChangeTypes.mouseUp:
      case downshift__WEBPACK_IMPORTED_MODULE_3__/* ["default"].stateChangeTypes.blurInput */ .ZP.stateChangeTypes.blurInput:
      case downshift__WEBPACK_IMPORTED_MODULE_3__/* ["default"].stateChangeTypes.keyDownEnter */ .ZP.stateChangeTypes.keyDownEnter:
      case downshift__WEBPACK_IMPORTED_MODULE_3__/* ["default"].stateChangeTypes.clickItem */ .ZP.stateChangeTypes.clickItem:
        return _objectSpread(_objectSpread({}, changes), {}, {
          inputValue: ''
        });

      case downshift__WEBPACK_IMPORTED_MODULE_3__/* ["default"].stateChangeTypes.keyDownEscape */ .ZP.stateChangeTypes.keyDownEscape:
        props.onSelectHandler(null);
        return changes;

      default:
        return changes;
    }
  };

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
    "data-testid": "search-dropdown",
    className: props.className,
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Select, {
      placeholder: props.placeholder,
      items: props.items,
      heading: props.heading,
      selectAllText: props.selectAllText,
      stateReducer: stateReducer,
      onSelectHandler: props.onSelectHandler,
      selectedItem: props.selectedItem
    })
  });
};

/***/ })

}]);